module.exports = __webpack_public_path__ + "public/Icons/mainSite.svg?0ac44883";